import type {ColorName} from 'shells/colors/colors';

import {FEEDBACK_SURVEYS} from './feedback-surveys';
import type {FeedbackSurvey} from './feedback-surveys';

export function isSurveyExpired(expireDate?: string | null): boolean {
    if (!expireDate) {
        return false;
    }

    const newDate = new Date(expireDate);

    return newDate < new Date();
}

export function matchSurvey(pathnameToMatch: string): FeedbackSurvey | null | undefined {
    for (const survey of FEEDBACK_SURVEYS) {
        for (const pathPattern of survey.pathNames) {
            // Escape regex special characters
            const escapedPattern = pathPattern.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&');
            const wildcardRegex = new RegExp(`^${escapedPattern.replace(/\*/g, '.*')}$`);

            if (wildcardRegex.test(pathnameToMatch) && isSurveyEnabled(survey)) {
                return survey;
            }
        }
    }

    return null;
}

export function isSurveyEnabled(survey: FeedbackSurvey): boolean {
    return survey.isEnabled ? survey.isEnabled() : true;
}

/** Resolved display props with required fields guaranteed */
type ResolvedDisplayProps = {
    bannerTitle: string;
    surveyTitle: string;
    surveySubtitle: string;
    feedbackPrompt: string | null | undefined;
    surveyImage: string | null | undefined;
    surveyImageBackgroundColor: ColorName | null | undefined;
};

/**
 * Returns display props, applying admin overrides if user is admin.
 * Base props are the default; adminProps overrides specific fields for admins.
 */
export function getDisplayProps(survey: FeedbackSurvey, isAdmin: boolean): ResolvedDisplayProps {
    const overrides = isAdmin && survey.adminProps ? survey.adminProps : {};

    return {
        bannerTitle: overrides.bannerTitle || survey.bannerTitle,
        surveyTitle: overrides.surveyTitle || survey.surveyTitle,
        surveySubtitle: overrides.surveySubtitle || survey.surveySubtitle,
        feedbackPrompt: overrides.feedbackPrompt || survey.feedbackPrompt,
        surveyImage: overrides.surveyImage || survey.surveyImage,
        surveyImageBackgroundColor:
            overrides.surveyImageBackgroundColor || survey.surveyImageBackgroundColor,
    };
}
